<template>
  <div class="product-list-container">
    <div class="product-grid">
      <div v-for="(item) in items" :key="item.id" class="product-card" @click="linkPdtDesc(item.id)">
        <div class="card-content">
          <img :src="item.image" :alt="item.title" class="product-image" />
          <h3 class="product-title">{{ item.title }}</h3>
          <p class="product-description"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
export default {
  name: "ProductList",
  computed: {
    // 使用computed属性确保语言切换时更新文本
    items() {
      return [
        {
          image: require('@/assets/product/T/36T2.jpg'),
          title: this.$t('products.product2.title'),
          description: this.$t('products.product2.description'),
          id: 2
        },
        {
          image: require('@/assets/product/L/36L2.jpg'),
          title: this.$t('products.product9.title'),
          description: this.$t('products.product9.description'),
          id: 9
        },
        {
          image: require('@/assets/product/T/47T2.jpg'),
          title: this.$t('products.product3.title'),
          description: this.$t('products.product3.description'),
          id: 3
        },
        {
          image: require('@/assets/product/L/47L2.jpg'),
          title: this.$t('products.product10.title'),
          description: this.$t('products.product10.description'),
          id: 10
        }
      ];
    }
  },
  methods: {
    linkPdtDesc(id) {
      this.$root.productId = id;
      router.push({
        name: 'Desc'
      });
    }
  }
};
</script>

<style scoped>
.product-list-container {
  padding: 20px;
  width: 80%;
  margin: 0 auto
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.product-card {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 12px #409eff;
}

.card-content {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  height: 100%;
}

.product-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.product-title {
  margin: 15px;
  font-size: 18px;
}

.product-description {
  margin: 0 15px 15px;
  color: #666;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .product-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 992px) {
  .product-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .product-grid {
    grid-template-columns: 1fr;
  }
}
</style>
